<template>
  <div class="register-container" :class="`lang-${lang}`" :style="{'background-image': `url(${modalBg})`}">
    <div class="register-content">
      <div class="title">
        <img v-if="titleBg" :src="titleBg" alt="title" />
        <span v-else>{{ locale.title || '' }}</span>
      </div>
      <div class="input-box" :style="{'background-image': `url(${inputBg})`}">
        <div v-if="lang == 'cn' || lang == 'tw' || lang == 'kr'" class="area" :style="{'background-image': `url(${areaBg})`}">
          <span v-if="lang == 'cn' || lang == 'tw'">+</span>
          <span name="code">{{ locale.code || '' }}</span>
          <span v-if="lang == 'kr'" class="kr-">-</span>
          <div v-if="lang == 'tw'" class="arrow-box">
            <div class="trigger" @click="handleCodeListToggle">
              <div class="arrow" :style="{'background-image': `url(${arrowBg})`}"></div>
            </div>
            <ul v-if="showCodeList" class="list">
              <li v-for="(item, i) in twCodeList" :key="i" @click="chooseCode(item.value)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <input type="text" v-model="locale.content" :placeholder="locale.placeholder || ''">
      </div>
      <div v-if="lang == 'tw'" class="tw-tip">
        <div class="input-checkbox">
          <input type="checkbox" id="twTip" ref="twTip">
          <label for="twTip" :style="{'background-image': `url(${checkboxBg})`}">
            <em :style="{'background-image': `url(${checkboxActiveBg})`}"></em>
          </label>
        </div>
        <span>{{ locale.tip }}</span>
      </div>
      <div v-if="lang == 'kr'" class="kr-tip">
        <div class="kr-check-all kr-tip-item">
          <div class="input-checkbox">
            <input type="checkbox" id="krTipAll" :checked="krTipCheckedAll" @click="krCheckAll">
            <label for="krTipAll" :style="{'background-image': `url(${checkboxBg})`}">
              <em :style="{'background-image': `url(${checkboxActiveBg})`}"></em>
            </label>
          </div>
          <span>모두 동의합니다</span>
        </div>
        <div class="line"></div>
        <div class="kr-tip-item" v-for="(item, i) in krTipList" :key="i" :class="`item-${item.id}`">
          <div class="input-checkbox">
            <input type="checkbox" :id="item.id" :checked="item.checked" @click="krCheck($event, item.id)">
            <label :for="item.id" :style="{'background-image': `url(${checkboxBg})`}">
              <em :style="{'background-image': `url(${checkboxActiveBg})`}"></em>
            </label>
          </div>
          <span>{{ item.tip }}</span>
          <div v-if="item.more" class="more" @click="showDetailTip(item.id)">+</div>
        </div>
      </div>
      <button class="submit" :style="{'background-image': `url(${submitBtnBg})`}" @click="submit">
        <span v-if="!loading">{{ locale.confirm || '' }}</span>
        <span v-else>loading...</span>
      </button>
    </div>

    <div v-if="lang == 'kr' && showDetailTipBox" class="detail-tip-box">
      <div
        v-show="showDetailTip1"
        class="kr-detail-tip1 detail-tip"
        :style="{'background-image': `url(${isMobile ? krTip1MobileBg : krTip1Bg})`}"
      >
        <div class="close" @click="closeDetailTip">×</div>
        <a href="https://protocol.xd.com/kr/torchlight/privacy-1.0.html" class="link-btn" target="_blank"></a>
      </div>
      <div
        v-show="showDetailTip2"
        class="kr-detail-tip2 detail-tip"
        :style="{'background-image': `url(${isMobile ? krTip2MobileBg : krTip2Bg})`}"
      >
        <div class="close" @click="closeDetailTip">×</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Toast from './toast/notice';

axios.defaults.timeout = 120000;

// 国内接口地址
const API_RESERVE_CN = 'https://poster-api.xd.cn/api/v1.0/reserve/reserve';
// 海外接口地址
const API_RESERVE_OS = 'https://poster-api.xd.com/api/v1.0/reserve/reserve';
// 繁中手机号前缀
const twCodeList = [
  { label: '台灣+886', value: 886 },
  { label: '香港+852', value: 852 },
  { label: '澳門+853', value: 853 }
];

export default {
  props: {
    lang: {
      type: String,
      default: () => 'en'
    },
    isOversea: Boolean,
    themeCode: {
      type: String,
      default: 'torchlight_s2',
    },
    storageKey: {
      type: String,
      default: 'torchlight-ep2',
    },
    titleBg: String,
    modalBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/6ZwBqmLk.jpg',
    },
    inputBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/6ZwBqvis.png',
    },
    submitBtnBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62fjGmIF.png',
    },
    areaBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62bFx7sx.png',
    },
    krTip1Bg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/64d6gyel.png',
    },
    krTip2Bg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62tAhxTl.png',
    },
    krTip1MobileBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/64d6gH8O.png',
    },
    krTip2MobileBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62yRweo1.png',
    },
    checkboxBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62o2gl2F.png',
    },
    checkboxActiveBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62o2gvAs.png',
    },
    arrowBg: {
      type: String,
      default: 'https://website.xdcdn.net/poster/227017/epicycle/ep-2/62ic4hQJ.png',
    },
  },
  data() {
    this.resizeTimer = null;

    return {
      cn: {
        title: '预约游戏',
        confirm: '确定',
        placeholder: '请输入手机号',
        code: 86,
        content: ''
      },
      tw: {
        title: '預約遊戲',
        confirm: '確定',
        placeholder: '請輸入手機號',
        tip: '同意我們向您的手機號碼發送最新賽季資訊與限定活動通知。（註：手機號有區號區分）',
        code: 886,
        content: ''
      },
      en: {
        title: 'Register Now',
        confirm: 'Confirm',
        placeholder: 'Email Address',
        content: ''
      },
      jp: {
        title: 'ゲームを予約',
        confirm: '確定',
        placeholder: 'メールボックスの入力ボックス',
        content: ''
      },
      kr: {
        title: '사전 예약',
        confirm: '확인',
        placeholder: '- 없이 휴대전화 번호 입력',
        code: '010',
        content: ''
      },
      twCodeList: twCodeList,
      showCodeList: false,
      krTipCheckedAll: false,
      krTipList: [
        { id: 'krTip1', tip: '만 14세 이상입니다.', checked: false },
        { id: 'krTip2', tip: '개인정보 수집 및 이용에 동의합니다.', checked: false, more: true },
        { id: 'krTip3', tip: '광고성 정보 수신에 동의합니다.', checked: false, more: true },
      ],
      showDetailTipBox: false,
      showDetailTip1: false,
      showDetailTip2: false,
      langMap: {
        cn: 'zh_CN',
        tw: 'zh_TW',
        en: 'en_US',
        jp: 'ja_JP',
        kr: 'ko_KR'
      },
      loading: false,
      code425: {
        cn: '您输入的号码错误请重新确认。',
        tw: '您輸入的號碼錯誤請重新確認。',
        en: 'Malformed phone number',
        jp: '不正な電話番号',
        kr: '잘못된 전화번호'
      },
      code408: {
        cn: '电子邮箱格式错误',
        tw: '電子郵箱格式錯誤',
        en: 'E-mail format error',
        jp: 'メールフォーマットエラー',
        kr: '이메일 형식 오류'
      },
      isMobile: false,
    }
  },
  computed: {
    locale() {
      return this[this.lang];
    },
    apiReserve() {
      return this.isOversea ? API_RESERVE_OS : API_RESERVE_CN;
    },
  },
  mounted() {
    this.listenResize();
    this.sortTwCodeList();
  },
  destroyed() {
    this.removeListenr();
    this.clearTimer();
  },
  methods: {
    // 排序
    sortTwCodeList() {
      if (this.lang !== 'tw') return;
      fetch('https://cf-ip.xd.com')
        .then((res) => res.json())
        .then((data) => {
          const region = data && data['xd-region'];
          switch(region) {
            case 'HK':
            this.setTwCode(852);
              break;
            case 'TW':
            this.setTwCode(886);
              break;
            case 'MO':
              this.setTwCode(853);
              break;
          }
        })
        .catch(() => {});
      
    },
    setTwCode(code) {
      const result = [];
      for(const item of twCodeList) {
        if (item.value === code) {
          result.unshift(item);
        } else {
          result.push(item);
        }
      }
      this.tw.code = code;
      this.twCodeList = result;
    },
    listenResize() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    },
    removeListenr() {
      window.removeEventListener('resize', this.handleResize);
    },
    handleResize() {
      this.clearTimer();
      this.resizeTimer = setTimeout(() => {
        this.isMobile = window.innerWidth <= 1024;
      }, 50);
    },
    clearTimer() {
      this.resizeTimer && clearTimeout(this.resizeTimer);
    },
    handleCodeListToggle() {
      this.showCodeList = !this.showCodeList
    },
    chooseCode(code) {
      this.tw.code = code
      this.showCodeList = false
    },
    krCheckAll(e) {
      this.krTipCheckedAll = e.target.checked;
      this.krTipList.forEach(item => {
        item.checked = this.krTipCheckedAll
      })
    },
    krCheck(e, id) {
      let sub_tip = this.krTipList.find((item) => item.id == id) || '';
      if(sub_tip) {
        let _checked = e.target.checked;
        sub_tip.checked = _checked;
        this.isAllChecked();
      }
    },
    isAllChecked() {
      let checkedCount = 0;
      this.krTipList.forEach(item => {
        if(item.checked) {
          checkedCount += 1
        }
      })

      if(checkedCount >= 3) {
        this.krTipCheckedAll = true;
      }else {
        this.krTipCheckedAll = false;
      }
    },
    closeDetailTip() {
      this.showDetailTipBox = false;
      this.showDetailTip1 = false;
      this.showDetailTip2 = false;
    },
    showDetailTip(id) {
      if(id == 'krTip2') {
        this.showDetailTip1 = true;
        this.showDetailTipBox = true;
      }else if(id == 'krTip3') {
        this.showDetailTip2 = true;
        this.showDetailTipBox = true;
      }
    },

    showValidateError() {
      let errMsg;

      switch(this.lang) {
        case 'cn':
          errMsg = '预约失败，请填写正确信息后重新尝试';
          break;

        case 'tw':
          errMsg = '請確認是否正確輸入您的電話號碼以及勾選同意';
          break;

        case 'kr':
          errMsg = '입력 정보가 정확하지 않습니다.다시한번 확인 부탁 드립니다';
          break;

        default:
          errMsg = 'PRE-REGISTER FAILED';
      }

      this.showError(errMsg);
    },

    showError(content, duration = 1.5) {
      Toast.info({
        content,
        duration,
      });
    },

    async submit() {
      if (this.loading) {
        return this.showError('Loading...');
      }

      const content = (this.locale.content || '').trim();

      if(!content) {
        this.showValidateError();
        return;
      }

      // 台湾 - 未勾选return
      if(this.lang == 'tw' && !this.$refs.twTip.checked) {
        this.showValidateError();
        return;
      }

      // 韩国 - 未全选return
      if(this.lang == 'kr' && !this.krTipCheckedAll) {
        this.showValidateError();
        return;
      }

      
      let data = {
        "theme_code": this.themeCode,
        "content": content,
        "area_code": Number(this.locale.code) || 0,
        "area": this.langMap[this.lang],
        "region": this.getCookie('xd-region')
      }

      this.loading = true;
      try {
        let res = await axios.post(this.apiReserve, data);
        this.loading = false;
        if(res.status == 200) {
          // 成功预约
          localStorage.setItem(this.storageKey, JSON.stringify('registed'))
          if(moo && moo.$bus) {
            moo.$bus.$emit('rocket:remote:module/torchlight-ep2-register:registed', res.status, res.data);
          }
        }
      } catch (error) {
        let res = {};
        this.loading = false;
        if (error.response) {
          res = {
            status: error.response.status || 0,
            data: error.response.data || ''
          }
        }else {
          res = {
            status: error.name || 0,
            data: error.message || ''
          }
        }

        if(res.status == 409) {
          // 已成功预约
          localStorage.setItem(this.storageKey, JSON.stringify('registed'));
          if(moo && moo.$bus) {
            moo.$bus.$emit('rocket:remote:module/torchlight-ep2-register:registed', res.status, res.data);
          }
        }else {
          this.locale.content = '';
          let msg = '';
          if(res.status == 425) {
            // 425 手机格式错误
            msg = this.code425[this.lang];
          }else if(res.status == 408) {
            // 408 邮箱格式错误
            msg = this.code408[this.lang];
          }else {
            if(res.data) {
              msg = res.data.message || 'Request Failed';
            }
          }

          msg && this.showError(msg);
        }
      }

      this.loading = false;
    },
    getCookie(cname) {
      var name = cname + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  }
}
</script>

<style lang="scss" scoped>
.register-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  .register-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .title {
    width: 100%;
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-top: 53px;
    span {
      font-size: 35px;
      font-weight: bolder;
      color: #A47DF1;
      line-height: 1.2;
      background: linear-gradient(180deg, #FFFFFF 0%, #7C40F2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    img {
      width: auto;
      height: 100%
    }
  }
  .input-box {
    width: 554px;
    height: 65px;
    margin: 90px auto 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    padding: 0 45px;
    .area {
      position: relative;
      width: 87px;
      height: 43px;
      margin: 0 18px 0 -32px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 20px;
        color: #D2D2D2;
        opacity: 0.6;
      }
      span.kr- {
        margin-top: -2px;
        margin-left: 2px;
      }
      .arrow-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        .trigger {
          width: 100%;
          height: 100%;
          .arrow {
            position: absolute;
            top: 19px;
            right: 9px;
            width: 8px;
            height: 6px;
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
          }
        }
        .list {
          position: absolute;
          top: 47px;
          left: 10px;
          width: 74px;
          padding: 3px 0;
          color: #88829B;
          font-size: 12px;
          border-radius: 5px;
          background-color: #180A48;
          z-index: 1;
          li {
            text-align: center;
            margin: 2px 0;
            cursor: pointer;
            &:hover {
              background-color: #180A67;
            }
          }
        }
      }
    }
    input {
      height: 43px;
      flex: 1;
    }
  }

  .tw-tip {
    display: flex;
    justify-content: center;
    margin-top: 21px;
    span {
      max-width: 420px;
      text-align: center;
      color: #D2D2D2;
      opacity: 0.6;
      margin-left: 5px;
      font-size: 15px;
    }
  }

  .kr-tip {
    width: 419px;
    height: 132px;
    margin-top: 14px;
    margin-left: auto;
    margin-right: auto;
    .line {
      width: 100%;
      height: 2px;
      background-color: #2C2B57;
      margin: 8px 0 7px;
    }
    .kr-tip-item {
      position: relative;
      width: 100%;
      height: 23px;
      display: flex;
      align-items: center;
      span {
        color: #D2D2D2;
        opacity: 0.6;
        font-size: 15px;
        margin-left: 40px;
      }
      .more {
        position: absolute;
        top: 4px;
        right: 20px;
        font-size: 26px;
        color: #D2D2D2;
        line-height: 0.65;
        font-weight: bolder;
        cursor: pointer;
      }

      &.item-krTip1, &.item-krTip2 {
        margin-bottom: 10px;
      }
    }
  }

  .submit {
    width: 271px;
    height: 71px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin: 73px auto 0;
    font-size: 28px;
    font-weight: bolder;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    span {
      background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 52.4%, #F0A6FF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
  }

  .detail-tip-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);

    .detail-tip {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -0.5 * 275px;
      margin-left: -0.5 * 732px;
      width: 732px;
      height: 275px;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      .close {
        color: #4B36C4;
        font-size: 34px;
        position: absolute;
        top: 20px;
        right: 25px;
        font-weight: bolder;
        cursor: pointer;
      }
    }
    .kr-detail-tip1 {
      position: relative;
      .link-btn {
        position: absolute;
        display: inline-block;
        width: 140px;
        height: 35px;
        right: 116px;
        bottom: 61px;
      }
    }
    .kr-detail-tip2 {}
  }


  &.lang-tw {
    .submit {
      margin: 29px auto 0;
    }
  }
  &.lang-kr {
    .input-box {
      margin: 44px auto 0;
    }
    .submit {
      margin: 14px auto 0;
    }
  }




  input {
    background: transparent;
    outline: none;
    border: none;
    font-size: 20px;
    color: #8C85A8;
    &:focus{
      outline: none;
    }
    &::placeholder {
      color: #8C85A8;
      font-size: 20px;
    }
  }

  button {
    background: none;
    outline: none;
    border: none;
  }

  .input-checkbox {
    position: relative;
    width: 19px;
    height: 18px;
    >input {
      display: none;
    }
    >label {
      display: inline-block;
      width: 19px;
      height: 18px;
      position: absolute;
      top: 0px;
      left: 0px;
      cursor: pointer;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    >label > em {
      display: inline-block;
      width: 100%;
      height: 100%;
      top: -2px;
      left: 4px;
      position: absolute;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      opacity: 0;
    }
    >input:checked+label > em{
      opacity: 1;
      transform: all 0.5s;
    }
  }
}

@function vw($px) {
  @return calc($px / 750px) * 100vw;
}

@media screen and (max-width: 750px) {
.register-container {
  width: vw(697px);
  height: vw(475px);
  .title {
    height: vw(73px);
    margin-top: vw(53px);
    span {
      font-size: vw(35px);
    }
  }
  .input-box {
    width: vw(554px);
    height: vw(65px);
    margin: vw(90px) auto 0;
    padding: 0 vw(45px);
    .area {
      width: vw(87px);
      height: vw(43px);
      margin: 0 vw(18px) 0 vw(-32px);
      span {
        font-size: vw(20px);
      }
      span.kr- {
        margin-top: vw(-2px);
        margin-left: vw(2px);
      }
      .arrow-box {
        .trigger {
          .arrow {
            top: vw(19px);
            right: vw(9px);
            width: vw(8px);
            height: vw(6px);
          }
        }
        .list {
          top: vw(47px);
          left: vw(10px);
          width: vw(100px);
          padding: vw(8px) 0;
          font-size: vw(18px);
          border-radius: vw(5px);
          li {
            margin: vw(5px) 0;
          }
        }
      }
    }
    input {
      height: vw(43px);
    }
  }

  .tw-tip {
    margin-top: vw(21px);
    span {
      max-width: vw(420px);
      margin-right: vw(5px);
      font-size: vw(15px);
    }
  }

  .kr-tip {
    width: vw(419px);
    height: vw(132px);
    margin-top: vw(14px);
    margin-left: vw(110px);
    .line {
      height: vw(2px);
      margin: vw(8px) 0 vw(7px);
    }
    .kr-tip-item {
      height: vw(23px);
      span {
        font-size: vw(15px);
        margin-left: vw(40px);
      }
      .more {
        top: vw(4px);
        right: vw(20px);
        font-size: vw(26px);
      }

      &.item-krTip1, &.item-krTip2 {
        margin-bottom: vw(10px);
      }
    }
  }

  .submit {
    width: vw(271px);
    height: vw(71px);
    margin: vw(73px) auto 0;
    font-size: vw(28px);
  }

  .detail-tip-box {
    .detail-tip {
      .close {
        font-size: vw(36px);
        top: vw(10px);
        right: vw(12px);
      }
    }
    .kr-detail-tip1 {
      width: vw(610px);
      height: vw(548px);
      margin-top: -0.5 * vw(548px);
      margin-left: -0.5 * vw(610px);
      .link-btn {
        right: vw(10px);
        bottom: vw(123px);
      }
    }
    .kr-detail-tip2 {
      width: vw(610px);
      height: vw(346px);
      margin-top: -0.5 * vw(346px);
      margin-left: -0.5 * vw(610px);
    }
  }


  &.lang-tw {
    .submit {
      margin: vw(29px) auto 0;
    }
    .input-box {
      margin-top: vw(40px);
    }
  }

  &.lang-kr {
    .input-box {
      margin: vw(44px) auto 0;
    }
    .submit {
      margin: vw(14px) auto 0;
    }
  }




  input {
    font-size: vw(20px);
    &::placeholder {
      font-size: vw(20px);
    }
  }

  .input-checkbox {
    width: vw(19px);
    height: vw(18px);
    >label {
      width: vw(19px);
      height: vw(18px);
    }
    >label::before {
      content: "";
      top: vw(-2px);
      left: vw(4px);
    }
  }
}
}
@media screen and (max-width: 414px) {
  .register-container {
    .tw-tip {
      span {
        max-width: vw(500px);
      }
    }
  }
}
</style>